import { Enum } from "controls";

// Список статусов
export class EnStatus extends Enum {
  // Приватный конструктор, чтобы объекты были синглтонами
  private constructor(x: string) {
    super(x);
  }

  static readonly DataEntered: EnStatus = new EnStatus("0");
  static readonly Ready: EnStatus = new EnStatus("1");
  static readonly Delete: EnStatus = new EnStatus("3");
  static readonly AgreementRefused: EnStatus = new EnStatus("4");
  static readonly SentToKD: EnStatus = new EnStatus("6");
  static readonly PassportArrived: EnStatus = new EnStatus("7");
  static readonly PassportValid: EnStatus = new EnStatus("9");
  static readonly PassportGranted: EnStatus = new EnStatus("10");
  static readonly PassportInvalid: EnStatus = new EnStatus("11");
  static readonly PersonalizationStart: EnStatus = new EnStatus("14");
  static readonly PersonalizationSuccess: EnStatus = new EnStatus("15");
  static readonly PassportSentToRKZU: EnStatus = new EnStatus("16");
  static readonly PassportDestroyed: EnStatus = new EnStatus("17");
  static readonly AgreementLetter: EnStatus = new EnStatus("19");
  static readonly ReceivedInKD: EnStatus = new EnStatus("20");
  static readonly OngoingAgreement: EnStatus = new EnStatus("21");
  static readonly AgreementGranted: EnStatus = new EnStatus("23");
  static readonly PassportPrintError: EnStatus = new EnStatus("25");
  static readonly Archived: EnStatus = new EnStatus("27");
  static readonly AgreementInvalidData: EnStatus = new EnStatus("28");
  static readonly PassportArrivedToRKZU: EnStatus = new EnStatus("29");
  static readonly Canceled: EnStatus = new EnStatus("30");
  static readonly AgreementAdditionalCheck: EnStatus = new EnStatus("31");
  static readonly ManualAgreement: EnStatus = new EnStatus("32");
  static readonly Inquiry: EnStatus = new EnStatus("33");
  static readonly PassportTransferedToGrantDesk: EnStatus = new EnStatus("34");
  static readonly Suspend: EnStatus = new EnStatus("35");
  static readonly ReadyForUrgentAgreement: EnStatus = new EnStatus("36");
  static readonly SendToAgreement: EnStatus = new EnStatus("37");
  static readonly RemovableMedia: EnStatus = new EnStatus("38");
  static readonly SentToMRCOD: EnStatus = new EnStatus("39");
  static readonly DocumentProductionCanceled: EnStatus = new EnStatus("40");
  static readonly PassportMailing: EnStatus = new EnStatus("41");
  static readonly PassportMarkedAsShouldBeDestroyed: EnStatus = new EnStatus("42");
  static readonly ActivateInKD: EnStatus = new EnStatus("43");
  static readonly PassportActivated: EnStatus = new EnStatus("44");
  static readonly NotificationOfRefusal: EnStatus = new EnStatus("45");
  static readonly PassportPrintNotify: EnStatus = new EnStatus("242");
  static readonly CopyPermission: EnStatus = new EnStatus("243");
  static readonly PriorityChange: EnStatus = new EnStatus("245");
  static readonly PaperAgreement: EnStatus = new EnStatus("246");
  static readonly PassportDataChange: EnStatus = new EnStatus("247");
  static readonly Restored: EnStatus = new EnStatus("249");
  static readonly AgreementModeChange: EnStatus = new EnStatus("251");
  static readonly MidCheckStart: EnStatus = new EnStatus("252");
  static readonly MidCheckValid: EnStatus = new EnStatus("253");
  static readonly MidCheckInvalid: EnStatus = new EnStatus("254");
  static readonly Resume: EnStatus = new EnStatus("255");
  static readonly AgreementRequestDelivered: EnStatus = new EnStatus("257");
  static readonly AgreementRequestVerified: EnStatus = new EnStatus("258");
  static readonly UndoEvent: EnStatus = new EnStatus("260");
  static readonly IncompleteRequest: EnStatus = new EnStatus("261");
  static readonly UndoActivity: EnStatus = new EnStatus("262");
  static readonly Comment: EnStatus = new EnStatus("263");
  static readonly MRCODPassportPrintRequest: EnStatus = new EnStatus("264");
  static readonly MRCODPassportGrant: EnStatus = new EnStatus("265");
  static readonly MRCODPassportNotGrant: EnStatus = new EnStatus("266");
  static readonly MRCODPassportNullify: EnStatus = new EnStatus("267");
  static readonly MRCODPassportPrintResponse: EnStatus = new EnStatus("268");
  static readonly MRCODPersonalizationStart: EnStatus = new EnStatus("269");
  static readonly MRCODLifecycleEnd: EnStatus = new EnStatus("270");
  static readonly GOSNIIASCitizenshipCheckStart: EnStatus = new EnStatus("271");
  static readonly GOSNIIASCitizenshipCheckResult: EnStatus = new EnStatus("272");
  static readonly GOSNIIASCitizenshipCheckTimeout: EnStatus = new EnStatus("273");
  static readonly GOSNIIASPassportCheckStart: EnStatus = new EnStatus("274");
  static readonly GOSNIIASPassportCheckResult: EnStatus = new EnStatus("275");
  static readonly GOSNIIASPassportCheckTimeout: EnStatus = new EnStatus("276");
  static readonly FPassportMailDeliveryModeToggle: EnStatus = new EnStatus("277");
  static readonly FPassportMailDeliveryInformationChange: EnStatus = new EnStatus("278");
  static readonly FPassportMailDeliveryTrackChange: EnStatus = new EnStatus("279");
  static readonly FingersRequiredChange: EnStatus = new EnStatus("280");
  static readonly FingersLoad: EnStatus = new EnStatus("281");
  static readonly FingersDelete: EnStatus = new EnStatus("282");
  static readonly RequestCauseChange: EnStatus = new EnStatus("283");
  static readonly SentSignedToMRCOD: EnStatus = new EnStatus("284");
  static readonly PersonalizationPermitted: EnStatus = new EnStatus("285");
  static readonly RussianPassportCheckStart: EnStatus = new EnStatus("286");
  static readonly RussianPassportCheckResult: EnStatus = new EnStatus("287");
  static readonly RussianPassportCheckTimeout: EnStatus = new EnStatus("288");
  static readonly PassportSafekeeping: EnStatus = new EnStatus("310");
  static readonly PassportEndSafekeeping: EnStatus = new EnStatus("320");
  static readonly RequestData: EnStatus = new EnStatus("500");
  static readonly CloneMany: EnStatus = new EnStatus("502");
  static readonly DeletePersonalData: EnStatus = new EnStatus("503");
  static readonly TryDeletePersonalData: EnStatus = new EnStatus("504");
  static readonly ResetAlarm: EnStatus = new EnStatus("505");
  static readonly Mistake: EnStatus = new EnStatus("600");
  static readonly ResetWorkTerminationReason: EnStatus = new EnStatus("601");
  static readonly WorkTerminationReasonCheckStateChanged: EnStatus = new EnStatus("602");
  static readonly CanceledOnLCOD: EnStatus = new EnStatus("603");
  static readonly OnPersonalizationOutbox: EnStatus = new EnStatus("604");
  static readonly PersonalizedOutbox: EnStatus = new EnStatus("605");
  static readonly TestEvent: EnStatus = new EnStatus("1000");
  // Устаревшие, но необходимо поддерживать, например для отображения в истории
  static readonly OnAgreement: EnStatus = new EnStatus("2");
  static readonly OnAgreementOld: EnStatus = new EnStatus("5");
  static readonly PassportRejected: EnStatus = new EnStatus("8");
  static readonly PassportLost: EnStatus = new EnStatus("12");
  static readonly Delivered: EnStatus = new EnStatus("13");
  static readonly PackageDeleted: EnStatus = new EnStatus("18");
  static readonly PassportProductionDecisionMade: EnStatus = new EnStatus("22");
  static readonly OnPersonalization: EnStatus = new EnStatus("24");
  static readonly PassportGrantedOld: EnStatus = new EnStatus("26");
  static readonly Clone: EnStatus = new EnStatus("244");
  static readonly RequestDataEdit: EnStatus = new EnStatus("248");
  static readonly AgreementFault: EnStatus = new EnStatus("256");
  static readonly FutureRequest: EnStatus = new EnStatus("259");
  static readonly IdentityFixed: EnStatus = new EnStatus("501");
  static readonly DelayedEvent: EnStatus = new EnStatus("999");

  static doesPassportExist(status: string): boolean {
    // Списки статусов отсюда: https://confluence.cqms.ru/pages/viewpage.action?pageId=17662048
    const passportExistsStatuses = new Set([
      EnStatus.MRCODPassportPrintResponse.toString(),
      EnStatus.PersonalizationSuccess.toString(),
      EnStatus.PassportArrived.toString(),
      EnStatus.PassportTransferedToGrantDesk.toString(),
      EnStatus.PassportSentToRKZU.toString(),
      EnStatus.PassportArrivedToRKZU.toString(),
      EnStatus.PassportValid.toString(),
      EnStatus.PassportGranted.toString(),
      EnStatus.Archived.toString(),
      EnStatus.PassportMailing.toString()
    ]);
    return passportExistsStatuses.has(status);
  }

  static doesStatementExist(status: string): boolean {
    const statementExistsStatuses = new Set([
      EnStatus.RequestData.toString(),
      EnStatus.Ready.toString(),
      EnStatus.SentToKD.toString(),
      EnStatus.RemovableMedia.toString(),
      EnStatus.Suspend.toString(),
      EnStatus.ReceivedInKD.toString(),
      EnStatus.SendToAgreement.toString(),
      EnStatus.ReadyForUrgentAgreement.toString(),
      EnStatus.PersonalizationStart.toString(),
      EnStatus.AgreementLetter.toString(),
      EnStatus.OngoingAgreement.toString(),
      EnStatus.AgreementGranted.toString(),
      EnStatus.ManualAgreement.toString(),
      EnStatus.SendToAgreement.toString(),
      EnStatus.SentToMRCOD.toString(),
      EnStatus.Inquiry.toString()
    ]);
    return statementExistsStatuses.has(status);
  }
}
